import type { ChangelogEntry } from "../types";

/** VIB-3050 PR 3b: pooler, leads i en pool og leadkort for admin. */
export const LEADLISTER_POOLER_2026_11: ChangelogEntry = {
  id: "2026-11-03-leadlister-pooler",
  date: "2026-11-03",
  title: "Leadlister: se og styr leadene i hver pool",
  summary:
    "Poolene viser hvor leadene er nå. Klikk en pool for å se leadene med status, og flytt mange på en gang. Hvert lead har et eget kort med tidslinje og forklaring på hvorfor det ligger der det ligger.",
  sections: [
    {
      heading: "Leadlister",
      items: [
        {
          title: "Hvor leadene er",
          kind: "forbedret",
          body: "Tabellen viser ledig, i køer, hviler, møter, kunde og avvist per pool. Har poolen lavvann, står «Under lavvann» når den må fylles på.",
          minRole: "admin",
        },
        {
          title: "Leads i en pool",
          kind: "nytt",
          body: "Klikk en pool for å søke, filtrere på status og segment, og velge flere leads. Tildel dem til en booker, send dem tilbake til poolen, flytt dem til en annen pool eller avvis dem. Erstatter «Se leads».",
          minRole: "admin",
        },
        {
          title: "Leadkort",
          kind: "nytt",
          body: "Hvert lead viser hvorfor det ligger der det ligger, med regelnummer, og en tidslinje med alle forsøk og hendelser. «Slett person» ligger nå her.",
          minRole: "admin",
        },
      ],
    },
  ],
};
